export default __webpack_public_path__ + "static/media/4H.8924ea52.svg";